module.exports = __webpack_public_path__ + "static/media/interac.44b7fc45.png";